/**
 * The one definition of the far-travel base path. Kept in its own tiny module
 * (no react/BFF imports) so client components can use it; far-travel.js
 * re-exports it.
 */
export const FAR_TRAVEL_BASE_PATH = '/verre-reizen';
